/** @format */

import React, { useEffect, useState } from 'react';
import { Container, Tab, Tabs, Toast } from 'react-bootstrap';

import LeftNavBar from 'components/Dashboard/LeftNavBar';
import InformationCenter from 'components/Dashboard/InformationCenter';
import AccessStation from 'components/Dashboard/AccessStation';
import Notifications from 'components/Dashboard/Notifications';

import { useSelector, useDispatch } from 'react-redux';
import { resetEmailReducer, logoutRequestAction } from 'stateContainer/actions';
import Header from '../../../components/Layout/Header';

export default function Dashboard(props) {
  const { accessStation, notifications } = props.t('lang_broker:dashboard');
  const leftBarNavText = props.t('lang_broker:leftbarnav');

  const infoCenter = props.t('lang_broker:infoCenter');
  const logOutModalText = props.t('lang_broker:logoutModal');
  const propertyTypeTranslation = props.t('lang_common:propertyType');
  const notificationStatusTranslation = props.t('lang_common:notification');
  const dispatch = useDispatch();

  const [showSuccessToast, setSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const {
    activeNav: { index },
    sendEmail,
    session: { sessionEndTime }
  } = useSelector((state) => state);

  useEffect(() => {
    if (sendEmail.showErrorToast) {
      setShowErrorToast(true);
      dispatch(resetEmailReducer());
    }

    if (sendEmail.showSuccessToast) {
      setSuccessToast(true);
      dispatch(resetEmailReducer());
    }
  }, [sendEmail]);

  useEffect(() => {
    const sessionHasExpired = new Date(sessionEndTime) < new Date();
    if (sessionHasExpired) {
      dispatch(logoutRequestAction());
    }
  }, [sessionEndTime]);

  useEffect(() => {
    const handleIsMobileSet = (currentState) => {
      if (isMobile !== currentState) {
        setIsMobile(currentState);
      }
    };
    const handleResize = () => handleIsMobileSet(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container fluid className='dashboard-main-container'>
      <Header {...props} dashboard={true} isMobileView={isMobile} />

      {!isMobile && (
        <LeftNavBar
          logOutModalText={logOutModalText}
          leftBarNavText={leftBarNavText}
        />
      )}

      <div className='dashboard-body-container'>
        {index === 0 && !isMobile && (
          <>
            <AccessStation text={accessStation} />
            <Notifications
              text={notifications}
              propertyTypeTranslation={propertyTypeTranslation}
              notificationStatusTranslation={notificationStatusTranslation}
            />
          </>
        )}

        {index === 0 && isMobile && (
          <div className='mobile-broker-dashboard-wrapper'>
            <Tabs
              id='broker-dashboard-tabs-mobile'
              defaultActiveKey='access-station'
              className=' nav nav-pills mb-3'>
              <Tab eventKey='access-station' title={accessStation.heading}>
                <AccessStation text={accessStation} displayHeading={false} />
              </Tab>
              <Tab eventKey='notifications' title={notifications.heading}>
                <Notifications
                  text={notifications}
                  displayHeading={false}
                  propertyTypeTranslation={propertyTypeTranslation}
                  notificationStatusTranslation={notificationStatusTranslation}
                />
              </Tab>
            </Tabs>
          </div>
        )}

        {index !== 0 && <InformationCenter text={infoCenter} />}
      </div>

      <Toast
        onClose={() => setSuccessToast(false)}
        show={showSuccessToast}
        delay={3000}
        autohide
        className='dashboard-success-toast'
        position={'top-end'}>
        <Toast.Body>{accessStation?.mail_success?.label}</Toast.Body>
      </Toast>

      <Toast
        onClose={() => setShowErrorToast(false)}
        show={showErrorToast}
        delay={3000}
        autohide
        className='dashboard-error-toast'
        position={'top-end'}>
        <Toast.Body>{accessStation?.mail_failed?.label}</Toast.Body>
      </Toast>
    </Container>
  );
}
